import { render, staticRenderFns } from "./PaseCampoModal.vue?vue&type=template&id=96c8f420"
import script from "./PaseCampoModal.vue?vue&type=script&lang=js"
export * from "./PaseCampoModal.vue?vue&type=script&lang=js"
import style0 from "./PaseCampoModal.vue?vue&type=style&index=0&id=96c8f420&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports